
export namespace GeometryTools {
    export function getCentroid(points: THREE.Vector3[]) {
        let centroid = new THREE.Vector3(0, 0, 0);
        for (let i = 0; i < points.length; i++) {
            centroid.x += points[i].x;
            centroid.y += points[i].y;
        }

        centroid.x /= points.length;
        centroid.y /= points.length;
        return centroid;
    }

    export function sortNonIntersecting(points: THREE.Vector3[]) {
        const center = getCentroid(points);
        return points.slice().sort((a: THREE.Vector3, b: THREE.Vector3) => {
            const angleA = Math.atan2(a.y - center.y, a.x - center.x);
            const angleB = Math.atan2(b.y - center.y, b.x - center.x);
            return angleA - angleB;
        })
    }

    export function getFragmentTriangles(renderProxy, floor_normal) {

        // transformation from fragment space to WCS
        var matrix = renderProxy.matrixWorld;

        // geometry data of the fragment
        var geometry = renderProxy.geometry;

        // information of the fragment
        var attributes = geometry.attributes;

        var vA = new THREE.Vector3();
        var vB = new THREE.Vector3();
        var vC = new THREE.Vector3();

        var result = new THREE.Geometry();
        var iv = 0;

        if (attributes.index !== undefined) {

            var indices = attributes.index.array || geometry.ib;
            var positions = geometry.vb ? geometry.vb : attributes.position.array;
            var stride = geometry.vb ? geometry.vbstride : 3;
            var offsets = geometry.offsets;

            if (!offsets || offsets.length === 0) {
                offsets = [{ start: 0, count: indices.length, index: 0 }];
            }

            for (var oi = 0, ol = offsets.length; oi < ol; ++oi) {

                var start = offsets[oi].start;
                var count = offsets[oi].count;
                var index = offsets[oi].index;

                for (var i = start, il = start + count; i < il; i += 3) {

                    var a = index + indices[i];
                    var b = index + indices[i + 1];
                    var c = index + indices[i + 2];

                    vA.fromArray(positions, a * stride);
                    vB.fromArray(positions, b * stride);
                    vC.fromArray(positions, c * stride);

                    vA.applyMatrix4(matrix);
                    vB.applyMatrix4(matrix);
                    vC.applyMatrix4(matrix);

                    var n = THREE.Triangle.normal(vA, vB, vC);

                    if (isEqualVectorsWithPrecision(n, floor_normal)) {

                        result.vertices.push(new THREE.Vector3(vA.x, vA.y, vA.z));
                        result.vertices.push(new THREE.Vector3(vB.x, vB.y, vB.z));
                        result.vertices.push(new THREE.Vector3(vC.x, vC.y, vC.z));
                        result.faces.push(new THREE.Face3(iv, iv + 1, iv + 2));
                        iv = iv + 3;
                    }
                }
            }
        }

        return result;
    }

    function isEqualVectorsWithPrecision(compared: THREE.Vector3, floor: THREE.Vector3): boolean {
        let tolerance = 0.1;
        return Math.abs(1 - floor.dot(compared)) < tolerance;
    }
}